
import AppViewEditor from "@/components/view-editor/ViewEditor.vue";
import { Browse } from "@/models/browse";
import { View } from "@/models/view";
import { BrowseService } from "@/services/browse-service";
import Vue from "vue";
import { AuthService } from "../../../services/auth-service";

export default Vue.extend({
	data() {
		return{
			browse: null as Browse | null,
			view: new View()
		};
	},
	async created() {
		let browseID = parseInt(this.$route.params.id);
		this.view.BrowseID = browseID;
		this.browse = (await BrowseService.getBrowse(browseID)).browse;
		if (AuthService.wfUser){
			this.view.UserID = AuthService.wfUser.ID;
		}
		this.view.BrowseID = this.browse.ID;
		this.view.Table = this.browse.Table;
	},
	components: {
		AppViewEditor
	}
});
